import Vue from 'vue'
import { getAttachText } from '@yw/hub.utilities.exclusive'
import { encryptPhone, encryptIdCard } from '@yw/hub.utilities.cryptr'

Vue.filter('capitalize', (str) => {
  if (!str) return ''
  str = str.toString()
  return `${str.charAt(0).toUpperCase()}${str.slice(1)}`
})
Vue.filter('toFixed2', (str) => {
  if (isNaN(str)) return ''
  else return Number(str).toFixed(2)
})
Vue.filter('hideCard', (idCard) => {
  if (!idCard) return ''
  return idCard.replace(idCard.slice(3, -4), idCard.slice(3, -4).replace(/\d/g, '*'))
})

Vue.filter('formatPriceForYuan', (val) => {
  if (!val) val = 0
  return (val / 100).toFixed(2)
})

Vue.filter('formatPriceForNumberYuan', (val) => {
  if (!val) val = 0
  return Number((val / 100).toFixed(2))
})

Vue.filter('formatPriceForYuanNoFixed', (val) => {
  if (!val) val = 0
  return (val / 100).toFixed(0)
})

Vue.filter('formatPriceForYuanUp', (val) => {
  if (!val) val = 0
  return Number((Math.ceil(val) / 100).toFixed(2))
})

Vue.filter('hidePhone', (str) => {
  if (!str) return ''
  return str.replace(/(\d{3})\d{4}(\d{4})/, '$1****$2')
})

Vue.filter('hideName', (str) => {
  if (!str) return ''
  if (str.length === 2 || str.length === 3) {
    return `*` + str.slice(1)
  }
  if (str.length >= 4) {
    return str.slice(0, 1) + `**` + str.slice(str.length - 1)
  }
})

Vue.filter('cgImg', function(url, width, height, multiple = 1) {
  if (!url || url.includes('imageMogr2/thumbnail')) {
    return url
  }
  if (width || height) {
    return ''
      .concat(url, '?imageMogr2/thumbnail/')
      .concat(width ? width * multiple : '', 'x')
      .concat(height ? height * multiple : '')
  }
  return url
})

const checkWebp = function() {
  try {
    return document.createElement('canvas').toDataURL('image/webp', 0.5).indexOf('data:image/webp') === 0
  } catch (err) {
    return false
  }
}
Vue.prototype.$cgWebpImg = function(url, width, height, multiple = 1) {
  if (!url || !checkWebp()) {
    return url
  }
  const reg = /\.(svg)$/.test(url)
  if (url.includes('?imageMogr2/thumbnail')) {
    if (url.includes('format/webp')) {
      return url
    }
    return ''.concat(url, '/').concat(!reg ? 'format/webp' : '')
  } else {
    if (width || height) {
      return ''
        .concat(url, '?imageMogr2/')
        .concat(!reg ? 'format/webp' : '', '/thumbnail/')
        .concat(width ? width * multiple : '', 'x')
        .concat(height ? height * multiple : '')
    }
  }
  return url
}
Vue.filter('cgWebpImg', function(url, width, height, multiple = 1) {
  if (!url || checkWebp()) {
    return url
  }
  const reg = /\.(svg)$/.test(url)
  if (url.includes('?imageMogr2/thumbnail')) {
    if (url.includes('format/webp')) {
      return url
    }
    return ''.concat(url, '/').concat(!reg ? 'format/webp' : '')
  } else {
    if (width || height) {
      return ''
        .concat(url, '?imageMogr2/')
        .concat(!reg ? 'format/webp' : '', '/thumbnail/')
        .concat(width ? width * multiple : '', 'x')
        .concat(height ? height * multiple : '')
    }
  }
  return url
})

Vue.filter('cgImg', (url, width, height, time = 1) => {
  if (!url) return url
  if (url.includes('imageMogr2/thumbnail')) return url
  if (width || height) {
    return `${url}?imageMogr2/thumbnail/${width ? width * time : ''}x${
      height ? height * time : ''
    }`
  }
  return url
})

Vue.filter('deliveryCycleFilter', function(val) {
  if (val <= 72) {
    return `${val}小时`
  }
  const days = Math.ceil(val / 24)
  if (days <= 60) {
    return `${days}天`
  } else {
    return `${Math.ceil(days / 30)}月`
  }
})

Vue.filter('formatPriceForYuanInt', function(val) {
  if (!val) val = 0
  const yuan = Number(val)
  if (!Number.isNaN(yuan)) {
    return yuan / 100
  }
  return ''
})

// 数字转文字
// <500的原样显示
// <10000的显示X000+
// >10000的x.x万+
Vue.filter('formatNumToSting', function(val) {
  if (!val || isNaN(val)) return 0
  if (val < 500) {
    return val
  } else if (val < 10000) {
    val = val.toString()
    return `${val.substring(0, 1)}${val.substring(1).replace(/\w/g, '0')}+`
  } else {
    return `${Math.floor(val / 10000 * 10) / 10}万+`
  }
})

Vue.filter('formatPriceForPointSplit', function(val, i) {
  if (!val) val = 0
  return (val / 100).toFixed(2).split('.')[i]
})

/**
 * 格式化已售数量
 */
Vue.filter('attachText', function(val, obj) {
  return getAttachText(val, obj)
})

// 手机号脱敏
Vue.filter('encryptPhone', function(val) {
  return encryptPhone(val)
})

// 身份证脱敏
Vue.filter('encryptIdCard', function(val) {
  return encryptIdCard(val)
})

// 统一社会信用代码脱敏
Vue.filter('encryptCuscc', function(val) {
  return (val || '').replace(/^(.{3}).*(.{4})$/, '$1*****************$2')
})
